<template>
    <section class="student-feedback">
        <HeaderList class="header-name" :user="feedback.user"></HeaderList>
        <work-content :id="'self'" :content="feedback.content" :isShowAudioPlayer="feedback.voice ? true : false"
            :audio="feedback.voice" :images="feedback.images
            " :imgSize="275" :imgHeight="275"></work-content>
        <div class="correct-time">
            <span>2023.02.13</span>
            <div @click="toEditFeedback" v-if="!feedback.is_correct">
                <img src="@/assets/housework/edit_blue.png" />
                修改
            </div>
        </div>
        <work-content class="" v-if="feedback.correct" :id="'comments'" :content="feedback.correct.content"
            :isShowAudioPlayer="feedback.correct.voice ? true : false" :audio="feedback.correct.voice"
            :images="feedback.correct.images" :type="'housework'"></work-content>
        <score class="student-score" v-if="feedback.correct && feedback.correct.score" :score="feedback.correct.score">
        </score>
    </section>
</template>

<script>
import HeaderList from '../HeaderList.vue'
import WorkContent from '../WorkContent.vue'
import Score from '../student/Score.vue'
export default {
    components: { HeaderList, WorkContent, Score },
    props: {
        feedback: [Object]
    },
    data () {
        return {
            isShowAudioPlayer: false
        }
    },
    methods: {
        toEditFeedback () {
            this.$emit('toEditFeedback')
        }
    }

}
</script>

<style lang="scss" scoped>
.student-feedback {
    position: relative;
    padding: 0 30px;
    box-sizing: border-box;

    .header-name {
        margin-top: 10px;
        line-height: 24px;
    }

    .correct-time {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding: 0 40px;
        box-sizing: border-box;
        font-size: 12px;
        color: #A5A5A5;

        div {
            cursor: pointer;
            color: #007AFF;

            img {
                vertical-align: bottom;
            }
        }
    }

    /deep/ .work-content {
        color: #262C31;

        &::after {
            content: '';
            display: block;
            clear: both;
        }

        // overflow: hidden;
        // 语音样式修改
        .audio-mock-player {
            width: 530px;

            // 隐藏语音关闭按钮
            .closeicon {
                display: none;
            }

        }
    }

    #self {
        margin-left: 30px;

        /deep/ p {
            // width: 530px;
        }
    }

    #comments {
        margin-top: 24px;
        padding: 20px 30px;
        height: auto;
        box-sizing: border-box;
        background: #F4F4F5;

        /deep/ p {
            margin-top: 0;
        }

        // .audio-player .audio-mock-player {

        /deep/ .audio-mock-player {
            background: #fff;
        }
    }

    // 学生得分
    .student-score {
        position: absolute;
        top: 10px;
        right: 40px;
    }



}
</style>>

</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/student/StudentFeedback.vue